module.exports = __webpack_public_path__ + "media/Kiki2.8e05275c.mp3";